<template>
    <div style="text-align: left; height: 100vh; background-color: #f5f5f5">
        <div style="padding: 15px; ">
            <!--<div style="font-size: 20px">请选择支付方式</div>-->
            <!--<div class="fs-18 p-t" style="margin-top: 5px">-->
            <!--<span>需支付</span>-->
            <!--<span class="text-danger fs-20">-->
            <!--{{formatMoneyYen(orderPackage.total,2)}}-->
            <!--</span>-->
            <!--<span>元</span>-->
            <!--</div>-->
        </div>
        <div class="pay-choose-radio-group clearfix">
            <div class="pay-choose-radio"
                 :class="{'pay-choose-radio-checked': payChooseIndex == 'ZFB'}"
                 @click="payChoose('ZFB')">
                <img style="width: 33px; height: 33px" src="../../assets/img/store/2支付方式_06-03.png"/>
                <div style="margin-left:10px; flex: 1; text-align: left">支付宝支付</div>
                <img v-if="payChooseIndex == 'ZFB'" style="width: 25px; height: 25px"
                     src="../../assets/img/store/2支付方式_13.png"/>
                <!--<img src="../../assets/img/store/pay-zfb.png">-->
                <!--<i></i>-->
            </div>
            <div class="pay-choose-radio"
                 style="border-top: 1px #eee solid"
                 :class="{'pay-choose-radio-checked': payChooseIndex == 'WX'}"
                 @click="payChoose('WX')">
                <img style="width: 33px; height: 33px" src="../../assets/img/store/2支付方式_03.png"/>
                <div style="margin-left:10px; flex: 1; text-align: left">微信支付</div>
                <img v-if="payChooseIndex == 'WX'" style="width: 25px; height: 25px"
                     src="../../assets/img/store/2支付方式_13.png"/>
                <!--<img src="../../assets/img/store/pay-wx.png">-->
                <!--<i></i>-->
            </div>
        </div>
        <div style="padding: 15px;">
            <van-button class="fs-16 pay-choose-btn"
                        style="width: 100%; border-radius: 100px;background-color: #07affa; color: white"
                        :disabled="payDis"
                        @click="createOrder(orderPackage, orderPackage.type)">
                确认支付 {{formatMoneyYen(orderPackage.total,2)}}元
            </van-button>
        </div>

        <!-- 支付弹框结果 - start -->
        <van-popup v-model="showModal"
                   style="width: 70%; padding: 20px; border-radius: 5px; font-size: 18px"
                   :close-on-click-overlay="false"
                   title="支付">
            <div style="margin-bottom: 20px" class="text-center m-b">支付结果</div>
            <div class="text-center">
                <van-button type="danger"
                            @click="queryPayStatus">支付异常
                </van-button>
                <van-button type="primary"
                            style="margin-left: 15px"
                            @click="queryPayStatus">支付成功
                </van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import head from '@/mixins/head';
    import {
        mapState,
        mapActions
    } from 'vuex';

    const STORE_ORDER_PACKAGE = 'STORE_ORDER_PACKAGE';
    export default {
        name: 'pay-choose',
        components: {},
        mixins: [head],
        data() {
            return {
                payChooseIndex: 'ZFB', //当前支付方式
                orderNo: '', //订单号
                activeIndex: '1',
                showModal: false,
                wxQrCodeUrl: '',
                payDis: false
            };
        },
        created() {
            this.inited();
        },
        mounted() {
            /**
             * 支付完成原生调用JS
             */
            window.payComplete = () => {
                this.queryPayStatus();
            };
        },
        watch: {
            '$route': 'inited' // 如果路由有变化，会再次执行该方法
        },
        computed: {
            ...mapState({
                userInfo: state => state.userInfo
            }),
            orderPackage() {
                let op = this.$storage.get(STORE_ORDER_PACKAGE);
                if (!op) {
                    op = { total: 0 };
                } else {
                    op = JSON.parse(op);
                }
                return op;
            }
        },
        methods: {
            inited() {
            },
            ...mapActions({// 将 `this.clearStoreCart()` 映射为 `this.$store.dispatch('clearStoreCart')`
                clearStoreCart: 'store/clearStoreCart'
            }),
            payChoose(v) {
                this.payChooseIndex = v;
            },
            /**
             * 立即购买
             * @param {*} data 请求所需要的数据
             * @param {*} type  1 应用中心 2 解决方案  3 增值服务
             */
            createOrder(data, type) {
                console.log('createOrder', data, type);

                let param = {
                    ...data,
                    // combineCodeList: data.combineCodeList,
                    total: Math.round(data.total * 100),
                    paymethodCd: this.payChooseIndex
                };
                if (type == '3_CALL') {
                    this.createOrderAppAction('buyCombineService_4.do', param);
                } else if (type == '3_NUM') {
                    // 数量 短信 云盘 客户数
                    this.createOrderAppAction('buyCombineService_3.do', param);
                } else if (type == '3_MES') {
                    // 短信类型服务
                    this.createOrderAppAction('buyCombineService_7.do', param);
                } else if (type == 3) {
                    this.createOrderAppAction('buyCombineService_2.do', param);
                } else if (type == 5) {
                    // 续费
                    this.createOrderAppAction('buyCombineService_5.do', param);
                } else if (type == 6) {
                    // 增值服务续费
                    this.createOrderAppAction('buyCombineService_6.do', param);
                } else {
                    this.createOrderAppAction('buyCombineService_1.do', param);
                }
            },
            createOrderAppAction(api, param) {
                this.payDis = true;
                this.$http.post('badu/BdServiceMarket/' + api, param).then((response) => {
                    let data = response.data;
                    // 1.未付款 2.已付款 3.已取消 4.无效
                    if ((data.state && data.state == 2) || param.total == 0) {
                        this.paySuccessApp();
                        this.payDis = false;
                        return;
                    }
                    this.showModal = true;
                    this.payDis = false;
                    this.orderNo = data.orderNo;
                    window.pay(data.orderNo, data.payUrl, data.paymethod);
                }).catch((err) => {
                    this.payDis = false;
                    console.log('createOrderAppAction', err);
                });
            },
            queryPayStatus() {
                let param = {
                    orderNo: this.orderNo
                };
                this.$http.post('badu/BdServiceMarket/queryCompanyPurchaseList.do', param).then((response) => {
                    let info = response.data;
                    if (info.serviceMarketVoList.length) {
                        let orderInfo = info.serviceMarketVoList[0];
                        // 1.未付款 2.已付款 3.已取消 4.无效
                        console.log('orderInfo', orderInfo, orderInfo.purchaseState);
                        if (orderInfo.purchaseState == 2) {
                            this.paySuccessApp();
                        } else {
                            this.payError();
                        }
                    }
                }).catch((err) => {
                    this.payError();
                    console.log('createOrderAppAction', err);
                });
            },
            // 支付成功 -> 完成配置
            // 支付中 -> 继续查询
            paySuccessApp() {
                this.showModal = false;
                this.PUSH({ name: 'store-pay-end' });
            },
            // 支付失败 -> 订单列表
            payError() {
                // window.toStoreOrder();
                // window.closeWindow();
                window.toStoreOrderAndFinish();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .choose-service-tabs {
        min-height: 600px;

        .el-tabs__item.is-left {
            padding: 10px 20px;
            height: 60px;
            font-size: 16px;

            .iconfont {
                margin-right: 8px;
            }
        }

        .el-tab-pane {
            padding-bottom: 220px;
        }
    }

    .choose-service-pay {
        position: absolute;
        bottom: 100px;
        left: 46%;
        font-size: 18px;
        text-align: center;

        .formatMoneyYen {
            color: #f56c6c;
            font-size: 30px;
        }
    }

    .fw500 {
        font-weight: 500 !important;
        padding-left: 12px;
    }

    .pay-choose-radio-group {
        font-size: 16px;
        background-color: white;
    }

    .pay-choose-radio {
        width: 100%;
        text-align: center;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 15px;
        background-color: white;
    }
</style>
